import { Link } from "react-router-dom";

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <header className="sticky top-0 z-10 bg-white/95 backdrop-blur-sm border-b border-gray-100">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="text-sm font-semibold text-teal-700 hover:text-teal-800">
            ← トップへ戻る
          </Link>
          <span className="text-sm text-gray-500">株式会社つくし映像</span>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900">プライバシーポリシー</h1>
        <p className="mt-4 text-base sm:text-lg text-gray-600 leading-relaxed">
          株式会社つくし映像（以下「当社」）は、当社が提供するドローン農薬散布代行サービスに関連して取得する個人情報を、
          以下の方針に基づき適切に取り扱います。
        </p>

        <div className="mt-10 space-y-10">
          <section>
            <h2 className="text-xl font-bold text-gray-900">1. 取得する情報</h2>
            <ul className="mt-4 space-y-2 text-base text-gray-700 leading-relaxed list-disc pl-6">
              <li>お名前、電話番号、メールアドレス</li>
              <li>圃場の所在地、面積、作物、散布希望時期などの見積もりに必要な情報</li>
              <li>お問い合わせ内容</li>
              <li>アクセス情報（閲覧状況、端末情報、Cookie等）</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900">2. 利用目的</h2>
            <ul className="mt-4 space-y-2 text-base text-gray-700 leading-relaxed list-disc pl-6">
              <li>お問い合わせへの対応、見積もり・提案、日程調整などの連絡</li>
              <li>サービス提供・運用に必要な手続き</li>
              <li>品質向上、サービス改善、分析</li>
              <li>不正利用の防止、セキュリティ確保</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900">3. 第三者提供</h2>
            <p className="mt-4 text-base text-gray-700 leading-relaxed">
              当社は、法令に基づく場合を除き、ご本人の同意なく個人情報を第三者に提供しません。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900">4. 委託</h2>
            <p className="mt-4 text-base text-gray-700 leading-relaxed">
              当社は、利用目的の達成に必要な範囲で、個人情報の取扱いを外部事業者へ委託する場合があります。その場合、適切な管理・監督を行います。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900">5. 安全管理</h2>
            <p className="mt-4 text-base text-gray-700 leading-relaxed">
              当社は、個人情報の漏えい・滅失・毀損等を防止するため、必要かつ適切な安全管理措置を講じます。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900">6. 開示・訂正・削除等</h2>
            <p className="mt-4 text-base text-gray-700 leading-relaxed">
              ご本人から個人情報の開示・訂正・利用停止・削除等の請求があった場合、法令に従い適切に対応します。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900">7. お問い合わせ窓口</h2>
            <p className="mt-4 text-base text-gray-700 leading-relaxed">
              本ポリシーに関するお問い合わせは、当サイトのお問い合わせフォームまたはお電話よりご連絡ください。
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900">8. 改定</h2>
            <p className="mt-4 text-base text-gray-700 leading-relaxed">
              当社は、必要に応じて本ポリシーを改定することがあります。改定後の内容は当ページにて掲示します。
            </p>
          </section>
        </div>
      </main>

      <footer className="border-t border-gray-100 py-8">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-sm text-gray-500 flex items-center justify-between">
          <span>&copy; 2026 株式会社つくし映像</span>
          <Link to="/" className="text-teal-700 hover:text-teal-800">トップへ</Link>
        </div>
      </footer>
    </div>
  );
}

